import {
  BrandingProvider,
  GLToastProvider as SPToastProvider,
} from '@group-link-one/gl-components';
import { SPBFFManager } from '@group-link-one/gl-ui/sonarprint';
import type { FlagsmithConfig } from '@group-link-one/gl-utils';
import { FlagsProvider, useAuth } from '@group-link-one/gl-utils';
import { BrandingRegistry } from './Branding/BrandingRegistry';
import { BlockedAccountProvider } from './Contexts/BlockedAccount';
import { ModalLogoutProvider } from './Contexts/GLModalLogout/ModalLogoutContext';
import { env } from './env';
import { useCallbackToModalLogout } from './hooks/useCallbackToModalLogout';
import { Routes } from './Routes/index.routes';

const flagConfig: FlagsmithConfig = {
  apiUrl: 'https://flagsmith.grouplinkone.com/api/v1/',
  environmentID: env.VITE_REACT_APP_FLAGS_ENV_KEY,
  cacheFlags: false,
  defaultFlags: {},
  enableLogs: false,
};

function App() {
  const { callbackFnToModalLogout } = useCallbackToModalLogout();
  const { user } = useAuth();

  return (
    <BrandingProvider brandingRegistry={BrandingRegistry} initialBranding={env.VITE_BRANDING}>
      <FlagsProvider config={flagConfig} user={user}>
        <BlockedAccountProvider>
          <ModalLogoutProvider callbackFnToModalLogout={callbackFnToModalLogout}>
            <SPToastProvider>
              <SPBFFManager />
              <Routes />
            </SPToastProvider>
          </ModalLogoutProvider>
        </BlockedAccountProvider>
      </FlagsProvider>
    </BrandingProvider>
  );
}

export default App;
